import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ScorecardSectionIntroProps {
  children: ReactNode;
  className?: string;
}

const ScorecardSectionIntro = ({ children, className }: ScorecardSectionIntroProps) => (
  <p className={cn("text-xs leading-5 text-muted-foreground", className)}>{children}</p>
);

export default ScorecardSectionIntro;
